import React, { useState } from 'react';
import type { RoomRate } from '@niarab2c/frontend-commons/src/types/hotels';
import { ResponsiveTooltip, Tooltip, useIsMobile } from '@niaratech/niara-react-components';
import { NiaraIcon } from '@niaratech/niara-icons';
import { Divider, Stack } from '@mui/material';
import AddonCardDetails from '../../Addon/AddonCardDetails';
import ModalOTA, { type ModalOTAProps } from '../../components/ModalOTA';
import * as S from './styles';
interface InclusionsProps {
  inclusions?: RoomRate['ratePlan']['inclusions'];
  /**
   * @default 10
   */
  initialVisibleInclusions?: number;
  addons?: RoomRate['addons'];
}
const Inclusions: React.FC<InclusionsProps> = props => {
  const {
    inclusions,
    initialVisibleInclusions = 10,
    addons: allAddons
  } = props;
  const isMobile = useIsMobile();
  const addons = allAddons?.reduce((acc, addon) => {
    if (acc?.findIndex(a => a?.addonId === addon?.addonId) < 0) {
      acc.push(addon);
    }
    return acc;
  }, []);
  const visibleQuantity = initialVisibleInclusions - (addons?.length || 0);
  const [showAmenitiesQuantity, setShowAmenitiesQuantity] = useState<number | undefined>(visibleQuantity);
  const showingAllAmenities = showAmenitiesQuantity === undefined;
  const [showAddonCardDetailsModal, setShowAddonCardDetailsModal] = useState(false);
  const [selectedAddon, setSelectedAddon] = useState<RoomRate['addons'][number] | undefined>();
  if (inclusions?.length < 1 && addons?.length < 1) {
    return null;
  }
  const onAddonClick = (addon: RoomRate['addons'][number]) => {
    setSelectedAddon(addon);
    setShowAddonCardDetailsModal(true);
  };
  return <S.InclusionContainer>
      {addons?.map(addon => {
      return !isMobile ? <Tooltip title={<S.AmenityTooltip>
                <p className="semibold">{addon?.addon?.name}</p>
                <p dangerouslySetInnerHTML={{
          __html: addon?.addon?.description?.join('<br>')
        }} />
              </S.AmenityTooltip>} placement="top">
            <Stack direction="row" alignItems="center" gap={'5px'} onClick={() => onAddonClick(addon)} sx={{
          cursor: 'pointer'
        }}>
              <Stack alignItems="center" justifyContent="center">
                <NiaraIcon icon="sysCircleCheck" />
              </Stack>
              <S.Inclusion className="bold">{addon?.addon?.name}</S.Inclusion>
            </Stack>
          </Tooltip> : <Stack direction="row" alignItems="center" gap={'5px'} onClick={() => onAddonClick(addon)} sx={{
        cursor: 'pointer'
      }}>
            <Stack alignItems="center" justifyContent="center">
              <NiaraIcon icon="sysCircleCheck" />
            </Stack>
            <S.Inclusion className="bold">{addon?.addon?.name}</S.Inclusion>
          </Stack>;
    })}
      {inclusions?.slice(0, showAmenitiesQuantity)?.map(inclusion => {
      return <ResponsiveTooltip<ModalOTAProps> modalComponent={ModalOTA} ModalProps={{
        title: inclusion?.name
      }} key={inclusion?.id} renderContent={() => <S.AmenityTooltip>
                <p className="bold">{inclusion?.name}</p>
                <p>{inclusion?.description}</p>
              </S.AmenityTooltip>}>
            <Stack direction="row" alignItems="center" gap={'5px'}>
              <Stack alignItems="center" justifyContent="center">
                <NiaraIcon icon="sysCheck" size={16} />
              </Stack>
              <S.Inclusion>{inclusion?.name}</S.Inclusion>
            </Stack>
          </ResponsiveTooltip>;
    })}
      {inclusions?.length > initialVisibleInclusions && <Stack direction="row" alignItems="center" gap={'5px'} alignSelf="center">
          <S.DividerContainer>
            <Divider orientation="vertical" sx={{
          margin: 0,
          borderColor: '#E6E6E6',
          width: '1px',
          height: '10px',
          display: 'flex'
        }} />
          </S.DividerContainer>
          <S.SeeAmenities onClick={() => {
        setShowAmenitiesQuantity(showingAllAmenities ? visibleQuantity : undefined);
      }}>
            {showingAllAmenities ? "Ver menos" : "Ver mais"}
          </S.SeeAmenities>
        </Stack>}
      {addons?.length > 0 && <ModalOTA show={showAddonCardDetailsModal} setShow={setShowAddonCardDetailsModal} mobileVariant="full" hideHeader showCloseButton padding="0" render={() => <AddonCardDetails showHeaderOnly addonResult={{
      addon: selectedAddon?.addon,
      results: [selectedAddon]
    }} />} />}
    </S.InclusionContainer>;
};
export default Inclusions;